// extracted by mini-css-extract-plugin
export var numpadContainer = "_or-1";
export var phoneButton = "_or-0";